import { Injectable } from '@angular/core';
import { Customer } from "./customer";
import { Observable } from "rxjs/Observable";
import { DatePipe } from '@angular/common';
import { SearchTableState } from "../search-table-state";
import { BaseService } from "../base.service";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class CustomerManagementService extends BaseService {

    public static searchUrl: string = '/api/users/search';
    public static getCustomerUrl: string = '/api/users';
    private static postDisableCustomerUrl: string = '/api/users/disableUser';
    private static getCustomersUrl: string = '/api/users/getCustomers';
    private static mergeCustomersUrl: string = '/api/users/mergeUsers';
    public searchTableState: SearchTableState = null;

    constructor(
        private http: HttpClient,
        private datePipe: DatePipe
    ) {
        super();
        this.searchTableState = new SearchTableState();
        this.searchTableState.propertyName = 'CreatedDateUtc';
    }

    private searchTableStateCopy() : any {
        let copy: any = Object.assign({}, this.searchTableState);
        /* Disable refresh search */
        copy.lastRefreshed = new Date();
        if (copy.lastRefreshed) {
            copy.lastRefreshed = new Date(copy.lastRefreshed.getTime() + -1 * (new Date().getTimezoneOffset() * 60000));
        }
        this.updateFilterField(copy, 'email', 'emailCondition');
        this.updateFilterField(copy, 'mobileNumber', 'mobileNumberCondition');
        this.updateFilterField(copy, 'externalId', 'externalIdCondition');
        return copy;
    }

    public search(): Observable<Array<Customer>> {
        let copy = this.searchTableStateCopy();
        return this.http.post<any>(CustomerManagementService.searchUrl, copy)
            .map(data => {
                let customers: Array<Customer> = this.dataToCustomer(data);
                this.searchTableState.totalItems = parseInt(customers.length ? data[0].Total : 0);
                return customers;
            });
    }

    private dataToCustomer(data: any): Array<Customer> {
        let customers = new Array<Customer>();
        if (data == null) {
            return customers;
        }
        for (let d of data) {
            let customer = new Customer();
            customer.userId = d.UserId;
            customer.mobileNumber = d.MobileNumber;
            customer.email = d.Email;
            customer.firstName = d.FirstName;
            customer.surname = d.Surname;
            customer.externalId = d.ExternalId;
            customer.statusId = d.StatusId == 2;
            customer.createdDateUtc = this.datePipe.transform(new Date(d.CreatedDateUtc), 'yyyy-MM-dd HH:mm');
            customers.push(customer);
        }
        return customers;
    }

    public getCustomer(id: string): Observable<Customer> {
        let params = new HttpParams()
            .set('id', id);
        return this.http.get<any>(CustomerManagementService.getCustomerUrl, { params: params })
            .map(data => {
                let customer = new Customer();
                customer.userId = data.UserId;
                customer.mobileNumber = data.MobileNumber;
                customer.email = data.Email;
                customer.firstName = data.FirstName;
                customer.surname = data.Surname;
                customer.externalId = data.ExternalId;
                customer.rewardCount = parseInt(data.RewardCount);
                customer.unitCount = parseInt(data.UnitCount);
                customer.permissionsValue = parseInt(data.PermissionsValue);
                if (data.Gender) {
                    customer.gender = data.Gender.toString();
                }
                customer.address1 = data.Address1;
                customer.address2 = data.Address2;
                customer.city = data.City;
                if (data.Province !== null) {
                    customer.provinceID = data.ProvinceID;
                }
                customer.suburb = data.Suburb;
                customer.postalCode = data.PostalCode;
                customer.country = data.Country;
                if(data.DateOfBirth != null) {
                    customer.dateOfBirth = new Date(data.DateOfBirth);
                }
               if(data.Anniversary != null) {
                customer.anniversary = new Date(data.Anniversary);
               }
                if(data.EnrollmentDate != null) {
                    customer.enrollmentDate = new Date(data.EnrollmentDate);
                }
                
                customer.receiveEmail = data.ReceiveEmail;
                customer.receiveSms = data.ReceiveSms;
               
                customer.statusId = data.StatusId == 2;
                return customer;
            });
    }

    public disableCustomer(id: string, disabled: boolean): Observable<any> {
        let params = new HttpParams()
            .set('id', id)
            .set('disabled', disabled.toString());
        return this.http.post<any>(CustomerManagementService.postDisableCustomerUrl, null, { params: params });
    }

    public getCustomers(): Observable<Array<Customer>> {
        return this.http.get(CustomerManagementService.getCustomersUrl)
            .map(data => {
                return this.dataToCustomer(data);
            });
    }

    public mergeCustomers(fromId: string, toId: string): Observable<any> {
        let params = new HttpParams()
            .set('fromId', fromId)
            .set('toId', toId);
        return this.http.post(CustomerManagementService.mergeCustomersUrl, null, { params: params });
    }
};


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/customer/customer-management.service.ts